import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const generateLinkToken = createAsyncThunk(
  "shareAbhaData/generateLinkToken",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/shareAbhaData/generateLinkToken",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const initiateLinking = createAsyncThunk(
  "shareAbhaData/initiateLinking",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/shareAbhaData/initiateLinking",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const initialState = {
  loading: false,
  linkTokenData: null,
  initiateLinkingData: null,
  error: null,
};

const shareAbhaDataSlice = createSlice({
  name: "shareAbhaData",
  initialState,
  reducers: {
    resetLinkTokenData: (state) => {
      state.linkTokenData = null;
      state.error = null;
    },
    resetInitiateLinkingData: (state) => {
      state.initiateLinkingData = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(generateLinkToken.pending, (state) => {
        state.loading = true;
      })
      .addCase(generateLinkToken.fulfilled, (state, action) => {
        state.loading = false;
        state.linkTokenData = action.payload;
      })
      .addCase(generateLinkToken.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(initiateLinking.pending, (state) => {
        state.loading = true;
      })
      .addCase(initiateLinking.fulfilled, (state, action) => {
        state.loading = false;
        state.initiateLinkingData = action.payload;
      })
      .addCase(initiateLinking.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetLinkTokenData, resetInitiateLinkingData } =
  shareAbhaDataSlice.actions;

export default shareAbhaDataSlice.reducer;
